import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ICliente, IPopulate, IQueryParam, ITipoCliente } from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';

import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../../../../../../auxiliares/dialog/dialog.service';
import { ISelectInfoBanner } from '../../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import { ClientesService } from '../../../../../../auxiliares/servicios/http/clientes.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../../auxiliares/tabla/filtro/filtro.component';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../../auxiliares/tabla/tabla.component';
import { FormularioDialogService } from '../../../../../../auxiliares/servicios/formulario-dialog.service';
import { ParamsService } from '../../../../../../auxiliares/servicios/params.service';
import { LoginService } from '../../../../../login/login.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../../auxiliares/servicios/cliente-jerarquia.service';
import {
  CambiarPadreDialogComponent,
  TipoOperacionCliente,
} from '../cambiar-padre-dialog/cambiar-padre-dialog.component';
import { escaparHtml } from '../../../../../../auxiliares/html-seguro.util';
import { IEstadoCelda } from '../../../../../../auxiliares/tabla/tabla.interfaces';
@Component({
  selector: 'app-clientes-tabla',
  templateUrl: './clientes.component.html',
  standalone: false,
})
export class ListadoClientesTablaComponent implements OnInit, OnDestroy {
  private lista2Service = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ClientesService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private formularios = inject(FormularioDialogService);
  paramsService = inject(ParamsService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private clientesService = inject(ClientesService);

  public datos: ICliente[] = [];
  public totalCount = 0;
  public columnas?: IColumnas<ICliente>[];
  public botonCrear: ICrearBoton = {
    // Un cliente Final no puede tener hijos (`setTipoCliente` del crear/editar
    // no le ofrece ningún tipo). Con la solapa oculta no debería llegar acá,
    // pero la URL sigue siendo accesible a mano.
    mostrar:
      this.helper.tienePermiso('Administración - Crear clientes') &&
      !this.helper.esClienteFinal(),
    tooltip: 'Crear cliente',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };

  public botonExportar: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Administración - Ver clientes'), // TODO: Crear permiso específico para exportar clientes si se considera necesario
    tooltip: 'Exportar clientes',
    color: 'primary',
    tipo: 'material',
    icon: 'file_download',
    accion: () => this.exportarClientes(),
  };

  public name = 'ListadoClientesTablaComponent';
  private populate: IPopulate = {
    path: 'padre',
    select: 'nombre',
  };
  public query: IQueryParam = {
    sort: 'nombre',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    populate: JSON.stringify(this.populate),
    includeChildren: true,
    childrenLevel: 0,
  };

  // Suscripciones
  public clientes$?: Subscription;

  public search: IRegExpSearch = {
    fields: ['nombre', 'numeroCliente'],
  };

  private tipoCliente: IFiltroTabla = {
    elementos: ['Mayorista', 'Minorista', 'Final'],
    filter: {
      field: 'tipoCliente',
    },
    label: 'Tipo de cliente',
    rapido: true,
    tipo: 'select',
  };
  public padre: IFiltroTabla = {
    filter: {
      field: 'idPadre',
    },
    label: 'Cliente padre',
    tipo: 'cliente-selector',
  };
  // Toda la descendencia de un cliente, él incluido. El filtro `padre` da solo
  // los hijos directos.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
      campoPropio: '_id',
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public modulos: IFiltroTabla = {
    elementos: [
      {
        label: 'Activos',
        value: [{ 'config.moduloActivos.activo': true }],
      },
      {
        label: 'Administración',
        value: [{ 'config.moduloAdministracion.activo': true }],
      },
      {
        label: 'Alarmas',
        value: [{ 'config.moduloAlarmasDomiciliarias.activo': true }],
      },
      {
        label: 'Transporte Público',
        value: [{ 'config.moduloColectivos.activo': true }],
      },
      {
        label: 'Servicio Técnico',
        value: [{ 'config.moduloEventosTecnicos.activo': true }],
      },
      {
        label: 'Vehículos',
        value: [{ 'config.moduloVehiculos.activo': true }],
      },
      {
        label: 'Luminarias',
        value: [{ 'config.moduloLuminarias.activo': true }],
      },
      {
        label: 'Emergencias Médicas',
        value: [{ 'config.moduloEmergencias.activoEmergenciasMedicas': true }],
      },
      {
        label: 'Logs',
        value: [{ 'config.moduloLogs.activo': true }],
      },
      {
        label: 'Twilio',
        value: [{ 'config.moduloTwilio.activo': true }],
      },
      {
        label: 'Sirenas',
        value: [{ 'config.moduloSirenas.activo': true }],
      },
      {
        label: 'Botón de Pánico BLE',
        value: [{ 'config.moduloBotonBLE.activo': true }],
      },
      {
        label: 'Integraciones',
        value: [{ 'config.modulosIntegraciones.activo': true }],
      },
    ],
    filter: {
      field: '$and',
    },
    label: 'Módulos',
    selectLabel: 'label',
    selectValue: 'value',
    tipo: 'select',
  };

  public filtros: IFiltroTabla[] = [
    this.tipoCliente,
    this.padre,
    this.ancestro,
    this.modulos,
  ];

  // Listados para filtros
  public async listar(): Promise<void> {
    this.clientes$?.unsubscribe();
    this.clientes$ = this.lista2Service
      .clientes(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.datos = data.datos.filter(
          (d) => d._id !== LoginService.getCliente()._id,
        );
      });
  }

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }

  public async editar(cliente: ICliente) {
    this.navigator.navigate(['editar', cliente._id], {
      relativeTo: this.route,
    });
  }
  public async notas(cliente: ICliente) {
    this.navigator.navigate(['detalles', cliente._id], {
      relativeTo: this.route,
    });
  }
  public async cambiarEstado(dato: ICliente): Promise<void> {
    const confirm = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Querés ${dato.habilitado ? 'deshabilitar' : 'habilitar'} el cliente?`,
    );
    if (confirm) {
      try {
        await this.service.update(dato._id!, { habilitado: !dato.habilitado });
        // dato todavía tiene el estado anterior: el aviso es el nuevo.
        this.helper.notifSuccess(
          dato.habilitado ? 'Cliente deshabilitado' : 'Cliente habilitado',
        );
        await this.listar();
      } catch (error) {
        this.helper.notifError(error);
      }
    }
  }

  public async eliminar(cliente: ICliente) {
    const dialogRef = this.formularios.abrir(CambiarPadreDialogComponent, {
      tamano: 'mediano',
      data: {
        idCliente: cliente._id!,
        nombreCliente: cliente.nombre,
        tipoOperacion: 'eliminarConMover' as TipoOperacionCliente,
      },
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      // Recargar los clientes para reflejar los cambios
      await this.listar();
    }
  }

  public async cambiarPadre(cliente: ICliente) {
    const dialogRef = this.formularios.abrir(CambiarPadreDialogComponent, {
      tamano: 'mediano',
      data: {
        idCliente: cliente._id!,
        nombreCliente: cliente.nombre,
        tipoOperacion: 'cambiarPadre' as TipoOperacionCliente,
      },
    });
    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      await this.listar();
    }
  }

  public async cambiarTipo(cliente: ICliente) {
    const todos: ITipoCliente[] = ['Mayorista', 'Minorista', 'Final'];

    // Consultas necesarias según tipo actual
    const [
      { datos: hijosInmediatosPorIdPadre },
      { datos: descendientesPorAncestros },
      { totalCount: cantHijos },
      { totalCount: cantHijosMayoristas },
      { totalCount: cantHijosMinoristas },
      padre,
    ] = await Promise.all([
      this.service.getFiltered({
        filter: JSON.stringify({ idPadre: cliente._id }),
        includeChildren: false,
        limit: 1000,
        sort: 'nombre',
      }),
      this.service.getFiltered({
        filter: JSON.stringify({ idsAncestros: cliente._id }),
        includeChildren: true,
        limit: 3000,
        sort: 'nombre',
      }),
      this.service.countDocuments({
        filter: JSON.stringify({ idPadre: cliente._id }),
        includeChildren: false,
      }),
      this.service.countDocuments({
        filter: JSON.stringify({
          idPadre: cliente._id,
          tipoCliente: 'Mayorista',
        }),
        includeChildren: false,
      }),
      this.service.countDocuments({
        filter: JSON.stringify({
          idPadre: cliente._id,
          tipoCliente: 'Minorista',
        }),
        includeChildren: false,
      }),
      cliente.idPadre
        ? this.service.getById(cliente.idPadre)
        : Promise.resolve(null),
    ]);

    const hijosInmediatosPorAncestros = descendientesPorAncestros.filter(
      (hijo) => hijo.idPadre === cliente._id,
    );

    const hijosInmediatosConsolidadosMap = new Map<string, ICliente>();
    [...hijosInmediatosPorIdPadre, ...hijosInmediatosPorAncestros].forEach(
      (hijo) => {
        if (hijo._id) hijosInmediatosConsolidadosMap.set(hijo._id, hijo);
      },
    );
    const hijosInmediatosConsolidados = Array.from(
      hijosInmediatosConsolidadosMap.values(),
    );

    const cantHijosConsolidados = hijosInmediatosConsolidados.length;
    const cantHijosMayoristasConsolidados = hijosInmediatosConsolidados.filter(
      (hijo) => hijo.tipoCliente === 'Mayorista',
    ).length;
    const cantHijosMinoristasConsolidados = hijosInmediatosConsolidados.filter(
      (hijo) => hijo.tipoCliente === 'Minorista',
    ).length;

    const tieneHijos = cantHijosConsolidados > 0;
    const hijosNoFinales =
      cantHijosMayoristasConsolidados + cantHijosMinoristasConsolidados;
    const tipoPadre = padre?.tipoCliente;
    const cantHijosPorIdPadre = hijosInmediatosPorIdPadre.length;
    const cantHijosPorAncestros = hijosInmediatosPorAncestros.length;

    if (
      cantHijos !== cantHijosConsolidados ||
      cantHijosMayoristas !== cantHijosMayoristasConsolidados ||
      cantHijosMinoristas !== cantHijosMinoristasConsolidados
    ) {
      console.warn(
        '[Clientes] Diferencia entre countDocuments y conteo consolidado de hijos inmediatos',
      );
    }
    console.groupEnd();

    // Calcular restricciones por tipo destino
    const restricciones: Partial<Record<ITipoCliente, string>> = {};

    if (cliente.tipoCliente === 'Minorista') {
      if (tieneHijos) restricciones['Final'] = 'tiene clientes hijos';
    } else if (cliente.tipoCliente === 'Final') {
      if (tipoPadre === 'Minorista') {
        restricciones['Minorista'] = 'su padre es Minorista';
        restricciones['Mayorista'] = 'su padre es Minorista';
      }
    } else if (cliente.tipoCliente === 'Mayorista') {
      if (tieneHijos && hijosNoFinales > 0)
        restricciones['Minorista'] = 'tiene hijos que no son Finales';
      if (tieneHijos) restricciones['Final'] = 'tiene clientes hijos';
    }

    const tiposValidos = todos.filter(
      (t) => t !== cliente.tipoCliente && !restricciones[t],
    );
    const tiposBloqueados = todos.filter(
      (t) => t !== cliente.tipoCliente && !!restricciones[t],
    );

    const resumenBloqueos = tiposBloqueados
      .map(
        (tipoBloqueado) =>
          `• <b>${tipoBloqueado}</b>: ${restricciones[tipoBloqueado]}`,
      )
      .join('<br>');
    const infoBannersBloqueos: ISelectInfoBanner[] = resumenBloqueos
      ? [
          {
            icon: 'info',
            color: 'blue',
            backgroundType: 'gradient',
            gradientDirection: 'to-right',
            title:
              tiposBloqueados.length > 1
                ? 'Tipos no disponibles'
                : 'Tipo no disponible',
            message: resumenBloqueos,
            closable: false,
            showBorder: true,
            margin: '0',
          },
        ]
      : [];

    if (tiposValidos.length === 0) {
      await this.dialogService.dialog(
        'No se puede cambiar el tipo',
        `No hay tipos disponibles para <b>${escaparHtml(cliente.nombre)}</b>.`,
        'Volver',
        infoBannersBloqueos,
      );
      return;
    }

    const mensajeBase = `Cliente: ${cliente.nombre} (actualmente ${cliente.tipoCliente}). Seleccioná el nuevo tipo.`;

    const seleccion = await this.dialogService.select(
      'Cambiar tipo de cliente',
      mensajeBase,
      'Tipo de cliente',
      tiposValidos,
      undefined,
      'Aceptar',
      'Cancelar',
      infoBannersBloqueos,
    );
    if (!seleccion) return;
    try {
      await this.service.cambiarTipoCliente(
        cliente._id!,
        seleccion as ITipoCliente,
      );
      this.helper.notifSuccess('Tipo de cliente actualizado correctamente');
      await this.listar();
    } catch (error) {
      this.helper.notifError(error);
    }
  }

  public async moverEntidades(cliente: ICliente) {
    const dialogRef = this.formularios.abrir(CambiarPadreDialogComponent, {
      tamano: 'mediano',
      data: {
        idCliente: cliente._id!,
        nombreCliente: cliente.nombre,
        tipoOperacion: 'moverEntidades' as TipoOperacionCliente,
      },
    });
    const result = await firstValueFrom(dialogRef.afterClosed());
    if (result) {
      await this.listar();
    }
  }

  // Exportar cliente

  public async exportarDispositivos(cliente: ICliente) {
    const res = await this.dialogService.confirm(
      'Exportar dispositivos',
      `¿Querés exportar los dispositivos de ${cliente.nombre}?`,
    );
    if (!res) return;
    try {
      await this.service.exportar(cliente._id, cliente.nombre);
      this.helper.notifSuccess('Documento exportado');
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Exportar tabla de clientes completa con cantidad de trackers y alarmas

  public async exportarClientes() {
    const res = await this.dialogService.confirm(
      'Exportar clientes',
      `¿Querés exportar la información de todos los clientes?`,
    );
    if (!res) return;
    try {
      await this.service.exportarClientes();
      this.helper.notifSuccess('Documento exportado');
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const columnas: IColumnas<ICliente>[] = [
      // Habilitado
      {
        header: {
          label: 'Habilitado',
          sortable: true,
          sort: 'habilitado',
        },
        row: {
          estado: (dato) =>
            dato.habilitado
              ? { texto: 'Habilitado', tono: 'ok', icono: 'toggle_on' }
              : { texto: 'Deshabilitado', tono: 'neutro', icono: 'toggle_off' },
        },
      },
      // Nombre
      {
        header: {
          label: 'Nombre',
          sortable: true,
        },
        row: {
          field: 'nombre',
        },
      },
      // Numero Cliente
      {
        header: {
          label: 'Número de cliente',
          sortable: true,
        },
        row: {
          field: 'numeroCliente',
          noData: 'Sin número',
        },
      },
      // Estado de cuenta
      {
        header: {
          label: 'Estado de cuenta',
          sortable: true,
          sort: 'estadoDeCuenta',
        },
        row: {
          estado: (dato) => this.estadoCuenta(dato),
          noData: 'Sin estado de cuenta',
        },
      },
      // Modulos Habilitados
      {
        header: {
          label: 'Módulos habilitados',
        },
        row: {
          // Con muchos módulos la fila crecía a 10+ renglones: se muestran los
          // tres primeros y el resto va en el tooltip.
          html: (dato) => {
            const modulos = this.modulosHabilitados(dato);
            if (!modulos.length) return '';
            const visibles = modulos.slice(0, 3).join(', ');
            const resto = modulos.length - 3;
            return resto > 0
              ? `${visibles} <span class="tabla-secundario">y ${resto} más</span>`
              : visibles;
          },
          tooltip: (dato) => this.modulosHabilitados(dato).join('<br>'),
          noData: 'Sin módulos',
        },
      },
      // Tipo de cliente
      {
        header: {
          label: 'Tipo de cliente',
          sortable: true,
        },
        row: {
          field: 'tipoCliente',
          noData: 'Sin tipo',
        },
      },
      // Credenciales de alarmas
      {
        header: {
          label: 'Credenciales de alarmas',
        },
        row: {
          // Tipo y usuario (o apikey) a la vista; la contraseña (o el
          // apisecret) enmascarada, con mostrar y copiar.
          secretos: (dato) => {
            const creds = dato.config?.credencialesAlarmas || [];
            if (!creds.length) return undefined;
            return creds.map((cred) => {
              const hik = cred.tipo === 'Hikvision';
              return {
                etiqueta: cred.tipo,
                visible: (hik ? cred.apikey : cred.usuario) || undefined,
                secreto: (hik ? cred.apisecret : cred.password) || '',
                que: hik ? 'Apisecret' : 'Contraseña',
              };
            });
          },
          noData: 'Sin credenciales',
        },
      },
      // Padre. Se muestra además la jerarquía de clientes en un tooltip: con
      // varios clientes de nombre parecido el nombre solo no alcanza para saber
      // de dónde cuelga el padre.
      {
        header: {
          label: 'Cliente padre',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.padre),
          tooltip: (dato) => this.clienteJerarquia.tooltipJerarquia(dato.padre),
          noData: 'Sin cliente padre',
        },
      },
      // Acciones
      {
        header: {
          label: 'Acciones',
        },
        row: {
          // Menú: Ver detalle, Editar, Eliminar y el submenú Más acciones
          accionesGrouped: [
            // Detalles
            {
              tipo: 'material',
              icon: 'visibility',
              tooltip: 'Ver detalle',
              click: (dato) => this.notas(dato),
              disabled: () =>
                !this.helper.tienePermiso('Administración - Ver clientes'),
            },
            // Editar
            {
              tipo: 'material',
              icon: 'edit',
              tooltip: 'Editar',
              click: (dato) => this.editar(dato),
              oculta() {
                return HelperService.getTipoCliente() === 'Final';
              },
              disabled: () =>
                !this.helper.tienePermiso('Administración - Editar clientes'),
            },
            // Eliminar
            {
              tipo: 'material',
              color: 'warn',
              icon: 'delete',
              tooltip: 'Eliminar',
              click: (dato) => this.eliminar(dato),
              oculta() {
                return HelperService.getTipoCliente() === 'Final';
              },
              disabled: () =>
                !this.helper.tienePermiso('Administración - Eliminar clientes'),
            },
            // Más Acciones
            {
              tipo: 'material',
              icon: 'more_vert',
              tooltip: 'Más acciones',
              children: [
                // Habilitar
                {
                  tipo: 'material',
                  icon: 'toggle_on',
                  tooltip: 'Habilitar',
                  oculta: (dato) => dato.habilitado,
                  click: (dato) => this.cambiarEstado(dato),
                  disabled: () =>
                    !this.helper.tienePermiso(
                      'Administración - Editar clientes',
                    ), // TODO: Crear permiso específico para habilitar/deshabilitar clientes si se considera necesario
                },
                // Deshabilitar
                {
                  tipo: 'material',
                  icon: 'toggle_off',
                  tooltip: 'Deshabilitar',
                  oculta: (dato) => !dato.habilitado,
                  click: (dato) => this.cambiarEstado(dato),
                  disabled: () =>
                    !this.helper.tienePermiso(
                      'Administración - Editar clientes',
                    ), // TODO: Crear permiso específico para habilitar/deshabilitar clientes si se considera necesario
                },
                // Exportar
                {
                  tipo: 'material',
                  icon: 'file_download',
                  tooltip: 'Exportar dispositivos',
                  click: (dato) => this.exportarDispositivos(dato),
                  oculta() {
                    return HelperService.getTipoCliente() === 'Final';
                  },
                  disabled: () =>
                    !this.helper.tienePermiso('Administración - Ver clientes'), // TODO: Crear permiso específico para exportar dispositivos de un cliente si se considera necesario
                },
                // Cambiar cliente padre
                {
                  tipo: 'material',
                  icon: 'account_tree',
                  tooltip: 'Cambiar cliente padre',
                  click: (dato) => this.cambiarPadre(dato),
                  oculta() {
                    return HelperService.getTipoCliente() === 'Final';
                  },
                  disabled: () =>
                    !this.helper.tienePermiso(
                      'Administración - Editar clientes',
                    ),
                },
                // Cambiar tipo de cliente
                {
                  tipo: 'material',
                  icon: 'category',
                  tooltip: 'Cambiar tipo de cliente',
                  click: (dato) => this.cambiarTipo(dato),
                  oculta() {
                    return HelperService.getTipoCliente() === 'Final';
                  },
                  disabled: () =>
                    !this.helper.tienePermiso(
                      'Administración - Editar clientes',
                    ),
                },
                // Mover entidades
                {
                  tipo: 'material',
                  icon: 'drive_file_move',
                  tooltip: 'Mover entidades a otro cliente',
                  click: (dato) => this.moverEntidades(dato),
                  oculta() {
                    return HelperService.getTipoCliente() === 'Final';
                  },
                  disabled: () =>
                    !this.helper.tienePermiso(
                      'Administración - Editar clientes',
                    ),
                },
              ],
            },
          ],
        },
      },
    ];

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    await Promise.all([this.listar()]);
  }

  ngOnDestroy() {
    this.clientes$?.unsubscribe();
  }

  /** Estado de cuenta con su tono: Activo, Moroso o Suspendido. */
  private estadoCuenta(dato: ICliente): IEstadoCelda | undefined {
    if (!dato.estadoDeCuenta) return undefined;
    switch (dato.estadoDeCuenta) {
      case 'Activo':
        return { texto: 'Activo', tono: 'ok', icono: 'check_circle' };
      case 'Moroso':
        return { texto: 'Moroso', tono: 'aviso', icono: 'warning' };
      case 'Suspendido':
        return { texto: 'Suspendido', tono: 'error', icono: 'block' };
      default:
        return { texto: dato.estadoDeCuenta, tono: 'neutro' };
    }
  }

  private modulosHabilitados(dato: ICliente): string[] {
    const c = dato.config;
    const modulos: [boolean | undefined, string][] = [
      [c?.moduloActivos?.activo, 'Activos'],
      [c?.moduloAdministracion?.activo, 'Administración'],
      [c?.moduloAlarmasDomiciliarias?.activo, 'Alarmas'],
      [c?.moduloColectivos?.activo, 'Colectivos'],
      [c?.moduloEventosTecnicos?.activo, 'Servicio Técnico'],
      [c?.moduloVehiculos?.activo, 'Vehículos'],
      [c?.moduloLuminarias?.activo, 'Luminarias'],
      [c?.moduloEmergencias?.activoEmergenciasMedicas, 'Emergencias Médicas'],
      [c?.moduloLogs?.activo, 'Logs'],
      [c?.moduloTwilio?.activo, 'Twilio'],
      [c?.moduloSirenas?.activo, 'Sirenas'],
      [c?.moduloBotonBLE?.activo, 'Botón de Pánico BLE'],
      [c?.modulosIntegraciones?.activo, 'Integraciones'],
    ];
    return modulos.filter(([activo]) => !!activo).map(([, nombre]) => nombre);
  }
}
